module.exports = __webpack_public_path__ + "static/img/ISO9001_Renwu__mobile.e949f2e5.jpg";